import React from 'react'
import PropTypes from 'prop-types'
import { Input } from 'components/common/FormElements/Input'

const EngineEditor = ({ input, ...props }) =>
  <Input { ...props } input={ input } />

export default EngineEditor

EngineEditor.propTypes = {
  input: PropTypes.shape()
}

